module.exports = __webpack_public_path__ + "static/media/svg-sprite.faddc1b3.svg";